import React from 'react';
import { I18n } from '@aws-amplify/core';
import FormItem from '@/components/ui/FormItem';
import InputText from '@/components/ui/InputText';
import type { FormItemProps } from '@/components/views/Resolution886/types';

export function SymptomLocationFormItem({ fieldName = '' }: Readonly<FormItemProps>): JSX.Element {
	function handleValidateSymptomLocation({ getFieldValue }: { getFieldValue: (path: string[]) => boolean }) {
		return {
			required: getFieldValue(['general_information', 'early_manifestation']) === true,
			message: I18n.get('Please enter a symptom location')
		};
	}

	return (
		<FormItem
			name={fieldName}
			label="Symptom location"
			dependencies={[['general_information', 'early_manifestation']]}
			rules={[handleValidateSymptomLocation]}
		>
			<InputText placeholder="Symptom location" />
		</FormItem>
	);
}
